import { useConfigStore } from '@/state/configStore';
import { useUiStore } from '@/state/uiStore';

export function Hud() {
  const config = useConfigStore((s) => s.config);
  const score = useConfigStore((s) => s.score);
  const rejections = useConfigStore((s) => s.rejections);
  const debug = useUiStore((s) => s.debug);

  if (!config) return null;

  return (
    <aside className="hud panel" aria-live="polite">
      <div>
        seed <strong>{config.seed}</strong> · preset <strong>{config.style.preset}</strong>
      </div>
      <div>
        stories {config.stories.length} · roof {config.roof.type} · score {(score?.total ?? 0).toFixed(2)}
      </div>
      {debug && rejections.length > 0 && (
        <details style={{ marginTop: 6 }}>
          <summary>rejections ({rejections.length})</summary>
          <ul style={{ margin: '4px 0 0 16px', padding: 0 }}>
            {rejections.map((r, i) => (
              <li key={i}>
                {r.score.toFixed(2)} — {r.reasons.join(', ') || 'below threshold'}
              </li>
            ))}
          </ul>
        </details>
      )}
    </aside>
  );
}
